import makeStyles from '@mui/styles/makeStyles';
import classNames from "classnames";
import {Heart} from "lucide-react";
import {get} from 'lodash';
import React from 'react';
import {useTranslation} from "react-i18next";
import {color, font, type} from "common/tokens";
import bulbImage from 'components/PostTypes/bulb.png';
import Card from "components/redesign/Card";

const useStyles = makeStyles(theme => ({
  post: {
    display: 'grid',
    gridTemplateColumns: '104px minmax(0, 1fr)',
    alignItems: 'center',
    gap: 16,
    background: color.EVENT_SURFACE,
    padding: 16,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'minmax(0, 1fr)',
    },
  },
  bulb: {
    width: '100%',
    height: 84,
    objectFit: 'contain',
    display: 'block',
  },
  body: {
    minWidth: 0,
  },
  eyebrow: {
    ...type.eyebrow,
    color: color.ACCENT_TEXT,
    margin: 0,
  },
  quote: {
    ...type.sessionTitle,
    color: color.TEXT,
    margin: '10px 0 0',
  },
  author: {
    ...type.meta,
    fontWeight: font.REGULAR,
    color: color.TEXT_MUTED,
    margin: '8px 0 0',
  },
  like: {
    appearance: 'none',
    background: 'none',
    border: 'none',
    padding: 0,
    marginTop: 14,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    cursor: 'pointer',
    color: color.TEXT_SUBTLE,
  },
  liked: {
    color: color.ACCENT,
  },
  likeCount: {
    ...type.label,
  },
}));

const QuotePost = ({post, toggleLike}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  const {feedLikes, isLiked, id} = post;
  const {text = t('postTitle'), author = t('author')} = get(post, 'contentObject');

  return (
    <Card variant={'media'} className={classes.post}>
      <img src={bulbImage} alt={''} className={classes.bulb}/>
      <div className={classes.body}>
        <p className={classes.eyebrow}>{t('quoteOfTheDay')}</p>
        <p className={classes.quote}>{text}</p>
        <p className={classes.author}>{`- ${author}`}</p>
        <button
          type={'button'}
          onClick={() => toggleLike(id)}
          className={classNames(classes.like, isLiked && classes.liked)}
        >
          <Heart size={15} fill={isLiked ? 'currentColor' : 'transparent'}/>
          <span className={classes.likeCount}>{feedLikes === 0 ? '' : feedLikes}</span>
        </button>
      </div>
    </Card>
  );
};

export default QuotePost;
